import { bankAccountConstants } from "../../constants";
import { IViewMerchantDedicatedTopUpAccount } from "../../interfaces-and-types";
import { View } from "./View";

export interface IAccountDetailsWithCopyButtonProps {
  // accounts_list: IResolveBankAccountResponse[];
  accounts_list: IViewMerchantDedicatedTopUpAccount[];
}

export const AccountDetailsWithCopyButton = (
  props: IAccountDetailsWithCopyButtonProps
) => {
  const accountsListMonniepointFirst = props.accounts_list.sort(
    (acc1, acc2) =>
      Number(acc2.bank_code === bankAccountConstants.MONNIEPOINT_BANK_CODE) -
      Number(acc1.bank_code === bankAccountConstants.MONNIEPOINT_BANK_CODE)
  );

  return <View accounts_list={accountsListMonniepointFirst} />;
};
